import { useParams } from 'react-router-dom';
import { useCustomNavigate, useDesign } from '@app/hooks';
import { IntentDetails, IntentDetailsMode } from '@app/page-components/modals';

export function EditIntentPage() {
  const { id } = useParams<{ id: string; }>();
  const design = useDesign();
  const navigate = useCustomNavigate();
  const intent = design.components.intents.find((intent) => {
    return intent.id === id;
  });

  if (!intent) {
    navigate('intents/management');
    return null;
  }

  return (
    <IntentDetails
      intent={intent}
      mode={IntentDetailsMode.edit}
      onComplete={(updatedIntent) => {
        if (updatedIntent) {
          Object.assign(intent, updatedIntent);
          window.apm.setSerializedChanged();
          window.apm.refreshApplicationTree();
        }

        navigate('intents/management');
      }}
    />
  );
}
